/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "models": {
                "nested": {
                  "AccountDetails": {
                    "fields": {
                      "fullAccountNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "routingNumber": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.models?.nested?.AccountDetails) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Limited details related to an SFS Account
 * --
 *
 * SOURCE AccountDetails @ squareup/sfs/external/models/account_details.proto at 10:1
 */
export const AccountDetails = $root.lookupType('squareup.sfs.external.models.AccountDetails');
fixType(AccountDetails);
Builder.createAndAttachToType(AccountDetails);